// extracted by mini-css-extract-plugin
export var accent = "ColorInput-module--accent--910bc";
export var input = "ColorInput-module--input--d5044";